import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createOpportunityType,
  deleteOpportunityType,
  findAllActiveOpportunityType,
  getAllOpportunityType,
  getOpportunityTypeById,
  OpportunityTypeActiveInactive,
  updateOpportunityType,
} from "./services/opportunityType.services";
import {
  IOpportunityType,
  IOpportunityTypeInitialState,
} from "./opportunityTypeModel";

const initialState: IOpportunityTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  OpportunityTypeID: null,
  OpportunityTypeList: [],
  OpportunityTypeDetail: {
    OpportunityType: "",
    IsActive: 1,
  },
};

export const opportunityTypeSlice = createSlice({
  name: "opportunityType",
  initialState,
  reducers: {
    clearOpportunityTypeDetails: (state) => {
      state.OpportunityTypeDetail = initialState.OpportunityTypeDetail;
    },
    setOpportunityTypeID: (state, action) => {
      state.OpportunityTypeID = action.payload;
    },
    clearOpportunityTypeID: (state) => {
      state.OpportunityTypeID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllOpportunityType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllOpportunityType.fulfilled,
      (state, action: PayloadAction<IOpportunityType[]>) => {
        state.loading = false;
        state.OpportunityTypeList = action.payload;
      }
    );
    builder.addCase(getAllOpportunityType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OpportunityTypeList = [];
    });
    builder.addCase(findAllActiveOpportunityType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActiveOpportunityType.fulfilled,
      (state, action: PayloadAction<IOpportunityType[]>) => {
        state.loading = false;
        state.OpportunityTypeList = action.payload || [];
      }
    );
    builder.addCase(findAllActiveOpportunityType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OpportunityTypeList = [];
    });
    builder.addCase(createOpportunityType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createOpportunityType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createOpportunityType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateOpportunityType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateOpportunityType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateOpportunityType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteOpportunityType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteOpportunityType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteOpportunityType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getOpportunityTypeById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getOpportunityTypeById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.OpportunityTypeDetail = action.payload;
    });
    builder.addCase(getOpportunityTypeById.rejected, (state, action) => {
      state.formLoading = false;
      state.OpportunityTypeDetail = initialState.OpportunityTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(OpportunityTypeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(OpportunityTypeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(OpportunityTypeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearOpportunityTypeDetails,
  setOpportunityTypeID,
  clearOpportunityTypeID,
} = opportunityTypeSlice.actions;
export default opportunityTypeSlice.reducer;
